import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, umsUrl } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { FAB_SURGE_GET_USER_ROLE, FAB_SURGE_GET_USER_ROLE_ERROR, FAB_SURGE_GET_USER_ROLE_SUCCESS } from '../../../actions.js';

function* getFabUserRole({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v2/organization-roles?tag=FAB`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: FAB_SURGE_GET_USER_ROLE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: FAB_SURGE_GET_USER_ROLE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: FAB_SURGE_GET_USER_ROLE_ERROR, payload: error });
  }
}

export function* watchGetFabUserRole() {
  yield takeEvery(FAB_SURGE_GET_USER_ROLE, getFabUserRole);
}

function* getFabUserRoleSaga() {
  yield all([fork(watchGetFabUserRole)]);
}

export default getFabUserRoleSaga;
